"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("@coreui/react");
function Toast({ bodyText, visible, setVisible }) {
    return ((0, jsx_runtime_1.jsx)(react_1.CToast, { autohide: false, visible: visible, color: "danger", className: "error-toast", children: (0, jsx_runtime_1.jsxs)("div", { className: "d-flex", children: [(0, jsx_runtime_1.jsx)(react_1.CToastBody, { children: bodyText }), (0, jsx_runtime_1.jsx)(react_1.CToastClose, { "data-testid": "toast-close", className: "me-2 m-auto", onClick: () => setVisible(false), white: true })] }) }));
}
exports.default = Toast;
